var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ion-chip',{class:{'small-chip': _vm.small},on:{"click":function($event){return _vm.$emit('click', _vm.item)}}},[_c('ion-label',[_vm._v(" "+_vm._s(_vm.label? _vm.label : _vm.item.name)+" ")]),_c('db-img',{attrs:{"icon":"","name":"close"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }